import React from "react";
import BlogSlider from "./BlogTopList";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import { Link } from "react-router-dom";

import blogs from "../../api/blogs";

const Icons = {
  arrow: (
    <>
      <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
        <rect x="3.783" y="13.463" width="14.31" height="1.817" transform="rotate(-40.2798 3.783 13.463)" fill="white" />
        <rect x="5.807" y="4.605" width="1.817" height="1.817" transform="rotate(-40.2798 5.807 4.605)" fill="white" />
        <rect x="8.367" y="4.816" width="1.817" height="1.817" transform="rotate(-40.2798 8.367 4.816)" fill="white" />
        <rect x="10.926" y="5.028" width="1.817" height="1.817" transform="rotate(-40.2798 10.926 5.028)" fill="white" />
        <rect x="13.277" y="7.8" width="1.817" height="1.817" transform="rotate(-40.2798 13.277 7.8)" fill="white" />
        <rect x="13.066" y="10.361" width="1.817" height="1.817" transform="rotate(-40.2798 13.066 10.361)" fill="white" />
        <rect x="12.855" y="12.922" width="1.817" height="1.817" transform="rotate(-40.2798 12.855 12.922)" fill="white" />
      </svg>

      <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
        <rect x="3.783" y="13.463" width="14.31" height="1.817" transform="rotate(-40.2798 3.783 13.463)" fill="white" />
        <rect x="5.807" y="4.605" width="1.817" height="1.817" transform="rotate(-40.2798 5.807 4.605)" fill="white" />
        <rect x="8.367" y="4.816" width="1.817" height="1.817" transform="rotate(-40.2798 8.367 4.816)" fill="white" />
        <rect x="10.926" y="5.028" width="1.817" height="1.817" transform="rotate(-40.2798 10.926 5.028)" fill="white" />
        <rect x="13.277" y="7.8" width="1.817" height="1.817" transform="rotate(-40.2798 13.277 7.8)" fill="white" />
        <rect x="13.066" y="10.361" width="1.817" height="1.817" transform="rotate(-40.2798 13.066 10.361)" fill="white" />
        <rect x="12.855" y="12.922" width="1.817" height="1.817" transform="rotate(-40.2798 12.855 12.922)" fill="white" />
      </svg>
    </>
  ),
};

const BlogList: React.FC = () => {
  return (
    <div>
      <BlogSlider />
      <section className="blog_details_section pt-120">
        <div className="container">
          <div className="row mt-none-50 g-0 align-items-start">
            <div className="col-lg-8 mt-50">
              <div className="blog_details_content">
                {blogs.map((blog, index) => {
                  const isImageItem = index % 2 === 0;
                  const postHref = `/blog/${blog.slug}`;

                  if (isImageItem) {
                    return (
                      <div
                        className="blog_details_item img-hove-effect ul_li xb-border"
                        key={blog.id}
                      >
                        <div className="xb-item--img xb-img">
                          {[1, 2, 3, 4].map((i) => (
                            <Link key={i} to={postHref}>
                              <img src={blog.image} alt={blog.title} />
                            </Link>
                          ))}
                        </div>

                        <div className="xb-item--holder">
                          <Link to={postHref} className="xb-item--tag">
                            #{blog.tag}
                          </Link>

                          <h3 className="xb-item--title border-effect-2">
                            <Link to={postHref}>{blog.title}</Link>
                          </h3>

                          <span className="xb-item--content">
                            {blog.excerpt}
                          </span>

                          <div className="xb-item--button mt-40">
                            <Link className="thm-btn agency-btn" to={postHref}>
                              <span className="text">Read more</span>
                              <span className="arrow">
                                <span className="arrow-icon">{Icons.arrow}</span>
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div className="blog_details_item xb-border" key={blog.id}>
                      <div className="xb-item--inner">
                        <Link to={postHref} className="xb-item--tag">
                          #{blog.tag}
                        </Link>

                        <h3 className="xb-item--title border-effect-2">
                          <Link to={postHref}>{blog.title}</Link>
                        </h3>

                        <span className="xb-item--content">
                          {blog.excerpt}
                        </span>

                        <div className="xb-item--button mt-40">
                          <Link className="thm-btn agency-btn" to={postHref}>
                            <span className="text">Read more</span>
                            <span className="arrow">
                              <span className="arrow-icon">{Icons.arrow}</span>
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}

              </div>
            </div>
            <BlogSidebar />
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogList;
